"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGradientColor = void 0;
var react_1 = require("react");
function useGradientColor(backgroundColor) {
    return react_1.useMemo(function () {
        return {
            topBackground: "linear-gradient(" + backgroundColor + ", rgba(255, 255, 255, 0.001))",
            bottomBackground: "linear-gradient(rgba(255, 255, 255, 0.001), " + backgroundColor + ")",
        };
    }, [backgroundColor]);
}
exports.useGradientColor = useGradientColor;
//# sourceMappingURL=useGradientColor.js.map